function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { useState as f, useEffect as d } from "react";
import i from "./index.es473.js";
import { getSortedStoredEmojis as u } from "./index.es219.js";
import { EMOJI_WRAPPER_TAG as E } from "./index.es216.js";
import a from "./index.es472.js";
var g = function g(n, s) {
    var _f = f(n),
      _f2 = _slicedToArray(_f, 2),
      c = _f2[0],
      m = _f2[1];
    return d(function () {
      var j = setTimeout(function () {
        return m(n);
      }, 500);
      return function () {
        clearTimeout(j);
      };
    }, [n, s]), c;
  },
  h = function h(n) {
    var _f3 = f([]),
      _f4 = _slicedToArray(_f3, 2),
      s = _f4[0],
      c = _f4[1],
      m = function m(o) {
        var e = i.instance.get();
        if (e) o.emoji in e ? i.instance.set(_objectSpread(_objectSpread({}, e), {}, _defineProperty({}, o.emoji, e[o.emoji] + 1))) : i.instance.set(_objectSpread(_objectSpread({}, e), {}, _defineProperty({}, o.emoji, 1)));else {
          var t = _defineProperty({}, o.emoji, 1);
          i.instance.set(t);
        }
      };
    return d(function () {
      var o = i.instance.get();
      if (o) {
        var e = u(o).map(function (t) {
          return a.find(function (r) {
            return r.emoji === t;
          });
        });
        c(e);
      }
    }, []), {
      recent: s,
      onEmojiChooseHandler: function onEmojiChooseHandler(o) {
        if (o.tagName === E) {
          var e = Object.values(a).find(function (t) {
            return t.emoji === o.textContent;
          });
          if (e) {
            m(e);
            var t = s.filter(function (r) {
              return r.emoji !== e.emoji;
            });
            c([e].concat(_toConsumableArray(t))), n(e.emoji);
          }
        }
      }
    };
  };
export { g as useDebounce, h as useRecent };